import { render } from "./MasonryGallery.vue?vue&type=template&id=631df94a&scoped=true"
import script from "./MasonryGallery.vue?vue&type=script&lang=js"
export * from "./MasonryGallery.vue?vue&type=script&lang=js"

import "./MasonryGallery.vue?vue&type=style&index=0&id=631df94a&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631df94a"]])

export default __exports__